export default __webpack_public_path__ + "static/media/Front-endAppReact_-_adamr.space___Codecademy.446e47cc.pdf";